import { Component } from 'react';
import React from 'react';
import PropTypes from 'prop-types';

class ShopBreadCrumbs extends Component {
  createBreadcrumbArray = () => {
    const { sfCategories, currentCategory } = this.props;

    const breadcrumb = [
      {
        id: currentCategory.id,
        name: currentCategory.name,
        path: currentCategory.path,
      },
    ];

    let current = currentCategory;

    while (current && current.parentId !== null) {
      const category = sfCategories.find((cat) => cat.id === current.parentId);
      if (!category) break;
      breadcrumb.unshift({
        id: category.id,
        name: category.name,
        path: category.path,
      });

      current = category;
    }

    return breadcrumb;
  };

  render() {
    const { currentCategory } = this.props;

    if (!currentCategory) return <></>;

    const breadcrumbLinks = this.createBreadcrumbArray();

    return (
      <>
        <a className='breadcrumbLink' href='/shop'>
          Shop
        </a>{' '}
        &#62;{' '}
        {breadcrumbLinks.map((cat, idx) => (
          <React.Fragment key={idx}>
            <a className='breadcrumbLink' href={`/shop${cat.path}`}>
              {cat.name}
            </a>
            {breadcrumbLinks.length - 1 !== idx && <> &#62; </>}
          </React.Fragment>
        ))}
      </>
    );
  }
}

ShopBreadCrumbs.propTypes = {
  sfCategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      parentId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.null,
      ]),
    })
  ).isRequired,
  currentCategory: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    parentId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.null,
    ]),
  }).isRequired,
};

export default ShopBreadCrumbs;
